const namespace = 'login'

export const LOGIN = `${namespace}/LOGIN`
export const LOGIN_SUCCESS = `${namespace}/LOGIN_SUCCESS`
export const LOGIN_ERROR = `${namespace}/LOGIN_ERROR`

export const RESET_LOGIN = `${namespace}/RESET_LOGIN`
